"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var placeholder = function (color) { return "color: " + color + ";"; };
exports.default = (function () { return function (_a) {
    var theme = _a.theme;
    return placeholder(theme.palette.inputPlaceholder);
}; });
